import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { AppContainer } from '@nutastic/nutastic-react-app';
import HomePage from '../pages/HomePage';
import Header from '../Header';
import AboutPage from '../pages/AboutPage';
import GalleryPage from '../pages/GalleryPage';
import ReservePage from '../pages/ReservePage';
import Sidebar from '../Sidebar';

const App = () => {
    const renderPageRoute = () => {
        return <Switch>
            <Route path='/' exact={true} component={HomePage}/>
            <Route path='/home' component={HomePage}/>
            <Route path='/about' component={AboutPage}/>
            <Route path='/gallery' component={GalleryPage}/>
            <Route path='/reserve' component={ReservePage}/>
        </Switch>;
    };

    return <AppContainer>
        <Header />
        <Sidebar />
        { renderPageRoute() }
        <footer>
            <span>Chelsi &amp; Spencer Wedding</span>
            <span>&copy; 2022 | All Rights Reserved, With Love</span>
        </footer>
    </AppContainer>;
};

export default App;
